import { FC, useMemo } from "react";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { scoreToDisplayStars } from "../../../config/rating";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

/**
 * Sticky Bar (v2) — admin-preview-only. "Top bar" and "Bottom bar" only
 * differ by which viewport edge widget-v2.js's renderBar fixes them to —
 * visually identical otherwise, so this preview doesn't branch on style.
 */
const WidgetTemplate29: FC<IWidgetTemplate> = ({ company, score }) => {
  const companyId = company?.companyId;
  const payload = useMemo(() => ({ companyId, widgetId: 29 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-bar`,
    [companyId],
  );
  const starsValue = scoreToDisplayStars(score?.score ?? 0);

  return (
    <a
      href={profileUrl}
      target="_blank"
      rel="noopener"
      onClick={() => ReachClick(payload)}
      className="d-flex align-items-center justify-content-center gap-2"
      style={{ textDecoration: "none", color: "#fff", background: "#1c1c2e", borderRadius: 6, padding: "6px 12px", fontSize: 10.5 }}
    >
      <StarRateNewTrustScore value={score?.score} size={9} />
      <span>
        <b>{starsValue}</b> · {(score?.totalReview ?? 0).toLocaleString()} verified reviews on{" "}
        <b style={{ color: "#69adff" }}>TrustFinance</b>
      </span>
      <span style={{ marginLeft: "auto", color: "#69adff", fontWeight: 600 }}>Read →</span>
    </a>
  );
};

export default WidgetTemplate29;
